import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Router, Route, Redirect, Switch} from 'react-router-dom'
import createBrowserHistory from 'history/createBrowserHistory'
import Login from '../pages/LoginPage'
import Splash from '../pages/SplashPage'
import Confirm from '../pages/ConfirmPage'
import Terms from '../pages/Terms'
import Contact from '../pages/Contact'
import ResetPassword from '../pages/ResetPasswordPage'
import SetPassword from '../pages/SetPassword'
import RequestPassword from '../pages/ForgotPasswordEmailEnter'
import {isAuthorized, APP_ADMIN_ROLE, ADMIN_ROLE} from '../utils'
import AdminRouter from "./AdminRouter";

const history = createBrowserHistory()

class App extends Component {
  
  PrivateRoute = ({component: Component, ...rest}) => {
    const {loginToken, role} = this.props
    return (<Route {...rest} component={props => {
      return loginToken && isAuthorized(rest.allowedUsers, role) ? (
        <Component {...rest} {...props} />
      ) : (
        <Redirect to={{
          pathname: '/',
          state: {from: props.location, allowedUsers: rest.allowedUsers}
        }}/>
      )
    }}/>)
  }

  render() {

    const PrivateRoute = this.PrivateRoute

    return (
      <Router history={history}>
        <Switch>
          <Route exact path='/' component={Login} history={history}/>
          <Route exact path='/login' component={Login} history={history}/>
          <Route exact path='/confirm' component={Confirm} history={history}/>
          <Route exact path='/terms' component={Terms} history={history}/>
          <Route exact path='/contact' component={Contact} history={history}/>
          <Route exact path='/reset-password' component={RequestPassword}/>
          <Route exact path='/recover-password/:resetPasswordToken' component={ResetPassword}/>
          <Route exact path='/set-password/:setPasswordToken' component={SetPassword}/>
          <PrivateRoute path='/admin' component={AdminRouter}
                        history={history}
                        allowedUsers={[APP_ADMIN_ROLE, ADMIN_ROLE]}
          />
        </Switch>
      </Router>
    )
  }
}

const mapStateToProps = ({login}) => {
  const {loginToken, role} = login
  return {loginToken, role}
}

export default connect(mapStateToProps, null)(App)
